import { EventInvites } from "@/components/shared/EventInvites";

export default function HostInvites({ profile, session }: { profile: any | null, session: any | null }) {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold">Event Invites</h1>
      </div>
      <EventInvites type="host" session={session} profile={profile} />
    </div>
  );
}